module.exports = "/assets/images/213d3b2414cd9f8a043b9171ed800909.jpg";